import { LoaderCircle } from 'lucide-react';

interface Props {
  message?: string;
  className?: string;
}

export function LoadingSpinner({ message, className = '' }: Props) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-12 ${className}`}>
      <LoaderCircle className="w-6 h-6 text-brand-orange animate-spin" />
      {message && <p className="text-sm text-slate-500">{message}</p>}
    </div>
  );
}
